import React from 'react'
import { Box, Grid } from '@mui/material'
import { makeSureIsArray } from '../../functions/general'
import NunitoText from '../general/NunitoText'
import ReusableButton from '../general/ReusableButton'
export default function ConfirmMEndDate({endDate, confirmFunction, cancelConfirm , OrgName}) {
    return (
        <Box className='popUpModal' style={{ width: 705, minHeight: 310 }}>
            <NunitoText value='CONFIRM CHANGES' fontSize={30} fontWeight={600} color='var(--color-primary)' marginTop={30} />
            <NunitoText value={`The Date you are About To Change Exceeds the Global Competition End Date Are you sure You want To change it ?`} fontSize={20} fontWeight={600} />
            <Grid container justifyContent="space-evenly" style={{ marginBlock: "30px 20px" }}>
                <ReusableButton text='Cancel' bgColor='var(--color-surface)' color='var(--color-primary)' borderColor='var(--color-border-strong)' fontSize={25} height={63} width={280}  
                    onClick={() => {cancelConfirm()
                        
                    }} />
                <ReusableButton text='Confirm' bgColor='var(--color-primary)' fontSize={25} height={63} width={280}
                    onClick={() => {
                       
                        confirmFunction()
                    }}   />
            </Grid>
        </Box>
    )
}